import React from "react";
import styles from "../../styles/Signup.module.scss";
import GenericInput from "../../containers/helpers/genericInput";
import LoaderButton from "../LoaderButton";
import ConfirmationCode from "../ConfirmationCode";
import classnames from "classnames";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

const ClientSignup = (props) => {
  const {
    fields,
    errorStateObject,
    handleFieldChange,
    isLoading,
    signupErrorText,
    passwordShown,
    fromBBClient,
    router,
    handleSubmit,
    togglePasswordVisiblity,
    showErrorText,
    passwordErrorText,
    inputStyles,
    scrollToLogin,
    confirmationData,
    passwordValidationObject,
    windowWidth,
    referral,
    isGuestCheckoutRegistration,
    emailIsReadOnly,
  } = props;

  // console.log(referral);
  const firstInputTabRef = React.createRef();

  const resetTab = () => {
    firstInputTabRef.current.focus();
  };

  const signupTextState = classnames({
    [styles.passwordDescClient]: true,
    [styles.error]: signupErrorText,
  });

  const passwordTextState = classnames({
    [styles.passwordDescClient]: true,
    [styles.error]: passwordErrorText,
  });

  const eightCharValidState = classnames({
    [styles.eightCharValid]: passwordValidationObject.eightChars,
    [styles.error]: passwordErrorText,
  });

  const oneNumberValidState = classnames({
    [styles.oneNumberValid]: passwordValidationObject.oneNumber,
    [styles.error]: passwordErrorText,
  });

  function guestCheckoutRegistrationElement() {
    return (
      <div className={styles.guestCheckoutRegistrationContainer}>
          <p><span className={styles.guestCheckoutRegistrationTextImportant}>
            Complete your account registration now to access your purchase.
          </span></p>
          {/* <p><span className={styles.guestCheckoutRegistrationText}>
            You will also receive an email with a link to this page.
          </span></p> */}
      </div>
    );
  }

  function renderSignupForm() {
    return (
      <div className={styles.clientSignupForm} id={"signup"}>
        {!referral && !isGuestCheckoutRegistration && (
          <span
            className={classnames(styles.returnToSignIn, styles.link)}
            onClick={() => scrollToLogin(props, windowWidth)}
          >
            <img
              className={styles.arrow}
              src={"https://frontend-assets.buildbox.com/Arrow+Up.svg"}
              alt="Return to sign in"
            />
            Return to Sign In
          </span>
        )}
        {isGuestCheckoutRegistration && guestCheckoutRegistrationElement()}

        <div className={signupTextState}>{showErrorText()}</div>
        <form className={styles.form} onSubmit={handleSubmit}>
            {/* Hidden fields for Stripe session */}
          <input
            type="hidden"
            name="proposedBuildboxUserId"
            value={fields.proposedBuildboxUserId}
          />
          <input
            type="hidden"
            name="oneTimeCode"
            value={fields.oneTimeCode}
          />
          <input
            type="hidden"
            name="isGuest"
            value={fields.isGuest}
          />

          <GenericInput
            type={"text"}
            title={""}
            placeholder={"Username"}
            inputName={"username"}
            inputValue={fields.username}
            changeCallback={handleFieldChange}
            styles={inputStyles}
            errorState={errorStateObject.username}
            ref={firstInputTabRef}
          />
          <GenericInput
            type={"text"}
            title={""}
            placeholder={"Name"}
            inputName={"name"}
            inputValue={fields.name}
            changeCallback={handleFieldChange}
            styles={inputStyles}
            errorState={errorStateObject.name}
          />
          <GenericInput
            type={"email"}
            title={""}
            placeholder={"Email"}
            inputName={"email"}
            inputValue={fields.email}
            changeCallback={handleFieldChange}
            styles={inputStyles}
            errorState={errorStateObject.email}
            readOnly={emailIsReadOnly}
          />
          <div className={styles.passwordDescContainerClient}>
            <GenericInput
              type={passwordShown ? "text" : "password"}
              title={""}
              placeholder={"Password"}
              inputName={"password"}
              inputValue={fields.password}
              changeCallback={handleFieldChange}
              styles={inputStyles}
              errorState={errorStateObject.password}
              icon={passwordShown ? faEye : faEyeSlash}
              iconClickHandler={togglePasswordVisiblity}
            />
          </div>
          <div className={passwordTextState}>
            Passwords must be at least{" "}
            {passwordValidationObject.eightChars && (
              <img
                alt="8 characters valid"
                src={
                  "https://frontend-assets.buildbox.com/passwordCheckmark.svg"
                }
                className={styles.passwordCheck}
              />
            )}
            <span className={eightCharValidState}> 8 characters </span>long and
            contain at least{" "}
            {passwordValidationObject.oneNumber && (
              <img
                alt="1 number valid"
                src={
                  "https://frontend-assets.buildbox.com/passwordCheckmark.svg"
                }
                className={styles.passwordCheck}
              />
            )}
            <span className={oneNumberValidState}> one number</span>
          </div>
          <GenericInput
            type={passwordShown ? "text" : "password"}
            title={""}
            placeholder={"Re-enter Password"}
            inputName={"confirmPassword"}
            inputValue={fields.confirmPassword}
            changeCallback={handleFieldChange}
            styles={inputStyles}
            errorState={errorStateObject.confirmPassword}
            icon={passwordShown ? faEye : faEyeSlash}
            iconClickHandler={togglePasswordVisiblity}
          />
          <LoaderButton
            isLoading={isLoading}
            onClick={handleSubmit}
            onBlurCallback={resetTab}
          >
            {" "}
            Create an Account{" "}
          </LoaderButton>
          <div className={styles.checkboxWrapper}>
            <div className={styles.policyCheckbox} htmlFor="policy">
              By clicking the "Create an Account", I agree to all Buildbox
              <a
                rel="noopener noreferrer"
                href="https://www.buildbox.com/terms/"
                target="_blank"
                className={styles.terms}
              >
                {" "}
                Terms of Service
              </a>
              ,
              <a
                rel="noopener noreferrer"
                href="https://www.buildbox.com/privacy-policy/"
                target="_blank"
                className={styles.terms}
              >
                {" "}
                Privacy Policy
              </a>
              , and{" "}
              <a
                rel="noopener noreferrer"
                href="https://www.buildbox.com/eula/"
                target="_blank"
                className={styles.terms}
              >
                {" "}
                EULA Agreements
              </a>
              .
            </div>
          </div>
        </form>
      </div>
    );
  }

  return (
    <div className={styles.signup}>
      {renderSignupForm()}
      <ConfirmationCode
        fromBBClient={fromBBClient}
        username={fields.username}
        password={fields.password}
        router={router}
        confirmationData={confirmationData}
        referral={referral}
      />
    </div>
  );
};

export default ClientSignup;
